import { render, staticRenderFns } from "./game-create.vue?vue&type=template&id=297a2c4c&"
import script from "./game-create.vue?vue&type=script&lang=ts&"
export * from "./game-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports